export default "__VITE_ASSET__DuTjuub8__"